import { useEffect } from "react"
import Footer from "../../Components/Footer"
import Header from "../../Components/Header"
import Loading from "../../Components/Loading"
import { useLandingContext } from "../../Context"
import fireload from "../../Services/firebaseConection"
import SectionContact from "./SectionContact"
import SectionCurriculo from "./SectionCurriculo"
import SectionFeedBacks from "./SectionFeedBacks"
import SectionPrimary from "./SectionPrimary"
import SectionServices from "./SectionServices"

function Home() {
  const useContext = useLandingContext()

  useEffect(() => {
    fireload()
    useContext.handleGetWebsiteSettings()
    useContext.handleGetFeedBacks()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const hasFeedbacks = useContext.feedBacks.length > 0

    if (!hasFeedbacks || useContext.controllerStop) return

    const timeoutId = setTimeout(() => {
      useContext.handleToggleActiveFeedBack("next")
    }, 15000)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [useContext.feedBacks, useContext.controllerStop])

  return (
    <>
      {useContext.loading && <Loading />}
      <Header />
      <SectionPrimary />
      <SectionCurriculo />
      <SectionServices />
      <SectionFeedBacks />
      <SectionContact />
      <Footer />
    </>
  )
}

export default Home
